import React from "react";
import { Button, Tag, Tooltip } from "@netapp/bxp-design-system-react";
import { CloseIcon } from "@netapp/bxp-style/react-icons/Action";
import styles from "./RoleTag.module.scss";

const RoleTag = ({ name, description, onClose, closeDisabled = false, closeLabel, inherited = false }) => (
    <Tag color={inherited ? "disabled" : "tag-1"} className={`${styles.tag} ${inherited ? styles.inherited : ""}`} style={{ display: "inline-flex", alignItems: "center", padding: (onClose || closeDisabled) ? "0 6px 0 10px" : "0 10px" }}>
        <span className={styles.label}>{name}</span>
        {description ? <Tooltip>{description}</Tooltip> : null}
        {(onClose || closeDisabled) && (
            <Button
                variant="icon"
                className={styles.close}
                aria-label={closeLabel || name}
                disabled={closeDisabled}
                onClick={(event) => {
                    event.stopPropagation();
                    if (!closeDisabled && onClose) {
                        onClose();
                    }
                }}
            >
                <CloseIcon />
            </Button>
        )}
    </Tag>
);

export default RoleTag;
